import React from "react";
import { Box, Link, Text, useColorModeValue } from "@chakra-ui/react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { SITE_STRIP_LINE } from "../../content/productGuide";

/** Renders strip or null — no color hooks here (avoids hooks-after-return lint edge cases). */
function PublicProductStripInner({ pathname, bg, border, text, linkCol }) {
  if (pathname === "/") return null;

  return (
    <Box
      bg={bg}
      borderBottomWidth="1px"
      borderColor={border}
      backdropFilter="blur(12px)"
      WebkitBackdropFilter="blur(12px)"
      py={{ base: 2.5, md: 3 }}
      px={{
        base: "max(1rem, env(safe-area-inset-left, 0px))",
        md: "max(1.5rem, env(safe-area-inset-left, 0px))",
      }}
      pr={{
        base: "max(1rem, env(safe-area-inset-right, 0px))",
        md: "max(1.5rem, env(safe-area-inset-right, 0px))",
      }}
      maxW="100%"
      overflowX="hidden"
    >
      <Text
        fontSize={{ base: "sm", md: "md" }}
        color={text}
        textAlign="center"
        lineHeight="tall"
        sx={{ overflowWrap: "anywhere" }}
      >
        {SITE_STRIP_LINE}{" "}
        <Link
          as={RouterLink}
          to="/#features"
          color={linkCol}
          fontWeight="semibold"
          _hover={{ textDecoration: "underline" }}
        >
          See the list →
        </Link>
      </Text>
    </Box>
  );
}

/**
 * Lightweight reminder on public pages (skipped on "/" where Features repeats this).
 */
const PublicProductStrip = () => {
  const location = useLocation();
  const bg = useColorModeValue(
    "rgba(240, 253, 250, 0.55)",
    "rgba(15, 23, 42, 0.45)"
  );
  const border = useColorModeValue("teal.100", "teal.800");
  const text = useColorModeValue("gray.700", "gray.100");
  const linkCol = useColorModeValue("teal.700", "teal.200");

  return (
    <PublicProductStripInner
      pathname={location.pathname}
      bg={bg}
      border={border}
      text={text}
      linkCol={linkCol}
    />
  );
};

export default PublicProductStrip;
